module.exports = __webpack_public_path__ + "img/f_r2_nightqueen.8bd44e34.jpg";